export const PRE_AUTH_PAYMENT_CONFIRMATION_QUOTE_SAMPLE = {
  organizationName: 'Stratos Jets',
  authExpiry: 'Saturday, October 23, 2025 at 14:00 (UTC -05)',
  quote: {
    quote_number: 'TR-1782460750614-961',
    passenger_count: 6,
    is_round_trip: true,
    is_multi_leg: false,
    departure_airport: 'TEB',
    arrival_airport: 'MIA',
    client: {
      first_name: 'Sarah',
      last_name: 'Mitchell',
      payment_info: {
        passport: {
          card: {
            brand: 'Visa',
            last4: '3456',
          },
        },
      },
    },
    bid_items: [
      {
        bid: {
          leg_itinerary: [
            {
              departure_airport: 'TEB',
              arrival_airport: 'MIA',
              departure_date: '2025-10-24T14:00:00',
            },
            {
              departure_airport: 'MIA',
              arrival_airport: 'TEB',
              departure_date: '2025-10-25T22:00:00',
            },
          ],
        },
      },
    ],
  },
  selectedBidOption: {
    operator_cost: 39258.70,
    federal_excise_tax: 2915.25,
    segment_tax: 31.20,
    card_fee: 1688.21,
    total_price: 42205.15,
    aircraft: {
      tail_number: 'N123GT',
      make_model: 'Hawker 800XP',
      description: "This Gulfstream G280 offers exceptional comfort and performance for your journey. With a range of 3,600 nautical miles and seating for up to 10 passengers, it's perfect for your TEB to MIA flight.",
      aircraft_features: {
        no_aog: true,
        custom_features: [
          'WiFi',
          'Entertainment System',
          'Full Galley',
          'Enclosed Lavatory',
          'Satellite Phone',
        ],
      },
    },
    operator: {
      name: 'Skyward Aviation',
      city: 'Teterboro',
      state: 'NJ',
      argus_rating: 'Platinum',
      wyvern_rating: 'Yes',
    },
  },
};
